import React from 'react'
import { Outlet } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import Navigate from '../navigation/Navigate'

const PrivateRoute = ({ rights }) => {
  const { user } = useAuth()
  const isAccessModule = () => {
    let is_access = false
    let right = null
    if (user.is_superAdmin) {
      is_access = true
      right = { is_edit: true, is_add: true, is_view: true, is_delete: true }
    }
    if (rights.module === 'Contracts' || rights.module === 'Tables') {
      if (rights.is_superAdmin !== undefined && rights.is_superAdmin && user.is_superAdmin) {
        is_access = true
        right = { is_edit: true, is_add: true, is_view: true, is_delete: true }
      }
    } else {
      if (user.company.contracts.length > 0) {
        const contract = user.company.contracts[0]
        const contractLine = contract.lines.find((line) => line.module === rights.module)
        if (contractLine) {
          const a = user.role.access_rights.find(
            (access) => access.module.module === rights.module && access[Object.keys(rights)[1]]
          )
          if (a !== null && contractLine.is_access) {
            is_access = true
            right = a
          }
        }
      } else {
        const a = user.role.access_rights.find(
          (access) => access.module.module === rights.module && access[Object.keys(rights)[1]]
        )
        if (a !== null) {
          is_access = a.module.is_free_account
          right = a
        }
      }
    }

    return { is_access: is_access, right: right }
  }

  if (!user) return <Navigate to='/login' />
  if (user) {
    const result = isAccessModule()
    if (result.is_access) {
      return <Outlet context={result.right} />
    } else {
      return <Navigate to='/' />
    }
  }
}

export default PrivateRoute
